import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_DELETE } from '../../constants/doctorTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';

// schema
import { doctorSchema } from '../../schemas/Normalizr';

export function* doctorDelete(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(DOCTOR_DELETE, call(doctorAPI.delete, params), doctorSchema);
  } catch (e) {
    const body = (e.response || {}).body || {};

    const errors = handleServerValidation('doctor', body.details, { nestedPath: true });

    yield put(error(DOCTOR_DELETE, errors));
  } finally {
    yield put(doneIndicator(DOCTOR_DELETE));
  }
}

export function* watchDoctorDelete() {
  yield takeEvery(DOCTOR_DELETE, doctorDelete);
}

export default function* root() {
  yield all([
    fork(watchDoctorDelete)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorDelete.js